import React from "react";
import styles from "./styles/cover-tab.module.scss";

type CoverTabProps = {
  title: string;
  fileName: string;
  fileUrl: string;
  activeTab: string;
  onClick: (fileName: string, fileUrl: string) => void;
};

const CoverTab = ({
  title,
  fileName,
  fileUrl,
  activeTab,
  onClick,
}: CoverTabProps) => {
  return (
    <div
      className={`${styles.container} ${title === activeTab ? styles.active : ""}`}
      onClick={() => onClick(fileName, fileUrl)}
    >
      {title}
    </div>
  );
};

export default CoverTab;
